import React from "react";

const Input = (props) => {
  const {
    boxStyle,
    inputStyle,
    type,
    name,
    id,
    label,
    placeholder,
    value,
    onChange = () => {},
    onBlur = () => {},
    hasError = false,
    isDisabled,
    errorMessage = "error",
  } = props;

  return (
    <span className={"flex gap-y-1 flex-col  w-full"}>
      <label htmlFor={id} className="text-white capitalize">
        {label}
      </label>
      <input
        className={"bg-[#333]  px-2 py-3 rounded-sm text-white"}
        id={id}
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={isDisabled}
      />

      <p
        className={`text-xs text-red  ${hasError ? "opacity-1 " : "opacity-0"}`}
      >
        {errorMessage}
      </p>
    </span>
  );
};

export default Input;
